import { PaymentMethodDetailPage } from '@/features/payment-method/pages/PaymentMethodDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/payment-method/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["payment_methods.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PaymentMethodDetailPage,
})
